import hooks from 'hooks';
import { isString, get } from 'lodash';
import { IsJsonString } from './index';
import { TIME_OUT_CLOSE_TOAST } from 'consts/data';

const { Notification } = hooks;

export const getError = (error) => {
  return error?.response?.data?.body || error.toString();
};

export const showError = (error, { ignore500Error } = { ignore500Error: false }) => {
  console.log('ERROR LOGGER: ', error);
  if (
    error?.ignoreShowMessage ||
    error?.isCanceled ||
    error === 'canceled' ||
    error?.code === 'ERR_CANCELED'
  ) {
    return;
  }

  //* Some APIs dont need show the toast if API 5xx
  if (ignore500Error) {
    if (error?.response?.status >= 500 && error?.response?.status <= 599) {
      return;
    }
  }

  const nameFieldsErrorFromServer = [
    'response.data.error',
    'response.data.reason',
    'response.data.body',
    'response.data.message',
    'response.data',
    'message',
  ];

  for (let i = 0; i < nameFieldsErrorFromServer.length; i++) {
    const field = nameFieldsErrorFromServer[i];
    const errorMsg = get(error, field);
    if (!!errorMsg) {
      if (IsJsonString(errorMsg)) {
        const jsonParsed = JSON.parse(errorMsg) || {};
        const message =
          get(jsonParsed, 'reason') ||
          get(jsonParsed, 'errorMessage') ||
          get(jsonParsed, 'error') ||
          get(jsonParsed, 'message');

        Notification('error', message, '', TIME_OUT_CLOSE_TOAST);
        return;
      }

      if (isString(errorMsg)) {
        Notification('error', errorMsg, '', TIME_OUT_CLOSE_TOAST);
        return;
      }
    }
  }

  Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
};

export const renderErrorForFormik = (error) => {
  if (typeof error === 'object') {
    return;
  }

  return error;
};

export const reponseError = (response) => {
  return response?.data?.error;
};
